import IssuuLookupResourceListResultModel from '../../generated/types/model/resource/IssuuLookupResourceListResultModel';

export default class IssuuLookupResourceListResultViewModel extends IssuuLookupResourceListResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
